import React, { useState, useEffect } from 'react'
import { StudentNavbar, SideNavigation, UserDashboardHeader } from '../components'
import { GoPeople } from "react-icons/go";
import { IoBookOutline } from "react-icons/io5";
import { PiNotepad } from "react-icons/pi";
import { IoMdArrowDropup, IoMdArrowDropdown } from "react-icons/io";
import bio from '../assets/biology.avif'
import lit from '../assets/literature.jpeg'
import hist from '../assets/history.jpeg'
import phys from '../assets/physics.jpeg'
import rel from '../assets/religion.jpeg'
import eng from '../assets/english.png'
import chem from '../assets/chemistry.avif'
import com from '../assets/commerce.jpeg'
import geo from '../assets/geography.jpeg'
import math from '../assets/math.webp'
import acc from '../assets/accounting.jpeg'
import { useNavigate } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import { faker } from "@faker-js/faker";

// import { Line, Bar } from 'react-chartjs-2';

const Progress = () => {

  const navigate = useNavigate();
  const userData = localStorage.getItem('userData');
  const userInfo = userData ? JSON.parse(userData) : null;

  // useEffect(() => {
  //   if (!userInfo || !userInfo.firstName) {
  //     navigate('/signin');
  //   }
  // }, [navigate, userInfo]);

  // if (!userInfo || !userInfo.firstName) {
  //   return null;
  // }

  // const data = {
  //   labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  //   datasets: [
  //     {
  //       label: 'Weekly Average Activity',
  //       data: [10, 15, 12, 20, 18, 22, 14], // Replace with your activity data
  //       borderColor: 'white',
  //       borderWidth: 2,
  //       fill: false,
  //     },
  //   ],
  // };
  

  // const options_line = {
  //   plugins: {
  //     legend: {
  //       labels: {
  //         color: 'white',
  //       },
  //     },
  //   },
  //   scales: {
  //     x: {
  //       title: {
  //         color: 'white', 
  //       },
  //       ticks: {
  //         color: 'white',
  //       },
  //       grid: {
  //         color: 'rgba(255, 255, 255, 0.1)', 
  //       },
  //     },
  //     y: {
  //       title: {
  //         color: 'white', 
  //       },
  //       ticks: {
  //         color: 'white',
  //       },
  //       grid: {
  //         color: 'rgba(255, 255, 255, 0.1)', 
  //       },
  //     },
  //   },
  // };

  // ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title, Legend);


  // const options = {
  //   responsive: true,
  //   plugins: {
  //     legend: {
  //       display: true,
  //       labels: {
  //         color: 'white',
  //       },
  //     },
  //   },
  //   scales: {
  //     x: {
  //       type: 'category', // Use 'category' for the x-axis
  //       ticks: {
  //         color: 'white',
  //       },
  //       grid: {
  //         color: 'rgba(255, 255, 255, 0.1)',
  //       },
  //     },
  //     y: {
  //       type: 'linear', // Use 'linear' for the y-axis
  //       beginAtZero: true,
  //       ticks: {
  //         color: 'white',
  //       },
  //       grid: {
  //         color: 'rgba(255, 255, 255, 0.1)',
  //       },
  //     },
  //   },
  // };
  
  
  
  const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
  
  const bar_data = {
    labels,
    datasets: [
      {
        label: 'Sciences',
        data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
      },
      {
        label: 'Business Studies',
        data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
      },
      {
        label: 'Language Arts',
        data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
        backgroundColor: 'purple',
      },
      {
        label: 'Mathematics',
        data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
        backgroundColor: 'lightblue',
      },
    ],
  };


  return (
    <div>
      <StudentNavbar className="fixed top-0 w-full z-50 !important" /> 
      <div className="w-full h-screen flex flex-col ">
        <UserDashboardHeader />
        <div className="flex py-10">
          <SideNavigation/>
          <div className="w-[75%] flex flex-col border-l border-[#fdfdfd]">
          <div className="pb-4 px-10">
            <Alert severity="info">This page is for demo purposes only. Updates coming soon!</Alert>
          </div>
          <p className="font-thin text-white text-4xl px-2 text-center">Top Three Courses</p>
            <div className="flex w-full justify-center">
                <div className="flex flex-col items-center w-[20%] h-[65%] bg-[#99A8D1] px-5 py-5 rounded-md  mx-10 my-10 hover:cursor-pointer">
                    <img className="rounded-[500px] w-[50px] h-[50px] shadow-xl" src={bio}/>
                    <p className="  text-lg text-black pt-2">Biology</p>
                    <div className="mt-2 shadow-xl bg-white w-full h-[25%] px-2 py-2 rounded-md flex grid grid-cols-3">
                      <div className="border-r-2 flex justify-center">
                        <IoBookOutline />
                        <p className="text-xs ml-[10%]">23</p>
                      </div>
                      <div className="border-r-2 flex justify-center">
                        <PiNotepad />
                        <p className="text-xs ml-[10%]">12</p>
                      </div>
                      <div className="flex justify-center">
                        <GoPeople />
                        <p className="text-xs ml-[10%]">87</p>
                      </div>
                    </div>
                </div>
                <div className="flex flex-col items-center w-[20%] h-[65%] bg-[#99C6D1] px-5 py-5 rounded-md mx-10 my-10 hover:cursor-pointer">
                    <img className="rounded-[500px] w-[50px] h-[50px] shadow-xl" src={lit}/>
                    <p className="  text-lg text-black pt-2">Literature</p>
                    <div className="mt-2 bg-white shadow-xl w-full h-[25%] px-2 py-2 rounded-md flex grid grid-cols-3">
                      <div className="border-r-2 flex justify-center">
                        <IoBookOutline />
                        <p className="text-xs ml-[10%]">23</p>
                      </div>
                      <div className="border-r-2 flex justify-center">
                        <PiNotepad />
                        <p className="text-xs ml-[10%]">12</p>
                      </div>
                      <div className="flex justify-center">
                        <GoPeople />
                        <p className="text-xs ml-[10%]">87</p>
                      </div>
                    </div>
                </div>
                <div className="flex flex-col items-center w-[20%] h-[65%] bg-[#99D1C3] px-5 py-5 rounded-md mx-10 my-10 hover:cursor-pointer">
                    <img className="rounded-[500px] w-[50px] h-[50px] shadow-xl" src={hist}/>
                    <p className="  text-lg text-black pt-2 ">History</p>
                    <div className="mt-2 shadow-xl bg-white w-full h-[25%] px-2 py-2 rounded-md flex grid grid-cols-3">
                      <div className="border-r-2 flex justify-center">
                        <IoBookOutline />
                        <p className="text-xs ml-[10%]">23</p>
                      </div>
                      <div className="border-r-2 flex justify-center">
                        <PiNotepad />
                        <p className="text-xs ml-[10%]">12</p>
                      </div>
                      <div className="flex justify-center">
                        <GoPeople />
                        <p className="text-xs ml-[10%]">87</p>
                      </div>
                    </div>
                </div>
            </div>
            <div className="">
              <p className="font-thin text-white text-4xl px-5 py-2 mb-4">Leader Board</p>
              <div style={{ borderColor: 'rgba(255, 255, 255, 0.2)' }} className="flex w-full px-5 pb-2 font-bold ">
                    <div className="flex flex-col w-full rounded-md">

                      <div className="text-white shadow-2xl flex py-4 w-full border-b-[1px] grid grid-cols-8">
                        <div className="">
                          <p className="mr-10 text-sm">RANK</p>
                        </div>
                        <div className="col-span-2">
                          <p className="text-sm">NAME</p>
                        </div>
                        <div className="col-span-2">
                          <p className="text-sm">SCHOOL</p>
                        </div>
                        <div className="">
                          <p className="text-sm">MAIN COURSE</p>
                        </div> 
                        <div className="">
                          <p className="text-sm text-center">HOUR</p>
                        </div>
                        <div className="">
                          <p className="text-sm text-center">POINTS</p>
                        </div>
                      </div>

                      <div style={{ borderColor: 'rgba(255, 255, 255, 0.5)' }} className="border-b bg-[#022935] rounded-md my-2 text-white flex w-full py-2 w-[100%] grid grid-cols-8 shadow-xl px-2 items-center">
                        <div className="col-span-1 flex">
                          <div className="text-black bg-gray-100 shadow-xl text-xs px-3 py-3 rounded-md">1</div>
                          <div className="pt-2 text-green-500 pl-2 ml-[10%]"><IoMdArrowDropup /></div>
                        </div>
                        <div className="font-thin col-span-2">Jack Sparrow</div>
                        <div className="font-thin col-span-2">Individual / No School</div>
                        <div className="font-thin">History</div>
                        <div className="font-thin text-center">220</div>
                        <div className="text-green-500 font-bold text-center">2200</div>
                      </div>

                      <div style={{ borderColor: 'rgba(255, 255, 255, 0.5)' }} className="border-b rounded-md  bg-transparent my-2 text-white flex w-full py-2 w-[100%] grid grid-cols-8 shadow-2xl px-2 rounde-md items-center">
                        <div className="col-span-1 flex">
                          <div className="bg-gray-100 shadow-xl text-black text-xs px-3 py-3 rounded-md">2</div>
                          <div className="pt-2 text-red-500 pl-2 ml-[10%]"><IoMdArrowDropdown /></div>
                        </div>
                        <div className="font-thin col-span-2">Elizabeth Swann</div>
                        <div className="font-thin col-span-2">Genesis Academy</div>
                        <div className="font-thin">History</div>
                        <div className="font-thin text-center">210</div>
                        <div className="text-green-500 font-bold text-center">2100</div>
                      </div>

                      <div style={{ borderColor: 'rgba(255, 255, 255, 0.5)' }} className="border-b rounded-md  bg-[#022935] text-white my-2 flex w-full py-2 w-[100%] grid grid-cols-8 shadow-2xl px-2  items-center">
                        <div className="col-span-1 flex">
                          <div className="bg-gray-100 shadow-xl text-black text-xs px-3 py-3 rounded-md">3</div>
                          <div className="pt-2 text-green-500 pl-2  ml-[10%]"><IoMdArrowDropup /></div>
                        </div>
                        <div className="font-thin col-span-2">Will Turner</div>
                        <div className="font-thin col-span-2">St. Augustine College</div>
                        <div className="font-thin">History</div>
                        <div className="font-thin text-center">100</div>
                        <div className="text-green-500 font-bold text-center">1000</div>
                      </div>

                      <div style={{ borderColor: 'rgba(255, 255, 255, 0.5)' }} className="border-b rounded-md  bg-transparent my-2 text-white flex w-full py-2 w-[100%] grid grid-cols-8 shadow-2xl px-2 rounde-md items-center">
                        <div className="col-span-1 flex">
                          <div className="bg-gray-100 shadow-xl text-black text-xs px-3 py-3 rounded-md">16</div>
                          <div className="pt-2 text-green-500 pl-2  ml-[5%]"><IoMdArrowDropup /></div>
                        </div>
                        <div className="font-thin col-span-2">Davy Jones</div>
                        <div className="font-thin col-span-2">Queen's College</div>
                        <div className="font-thin">History</div>
                        <div className="font-thin text-center">64</div>
                        <div className="text-green-500 font-bold text-center">640</div>
                      </div>

                    </div>
                  </div>
            </div>
            <div className="px-5 pb-2">
              <p className="font-thin text-white text-4xl pt-10 pb-2">Performance</p>
              <div className="flex w-[100%] justify-center rounded-md">

                  <div className="border-[1px] flex flex-col rounded-md shadow-xl px-5 py-5 text-center mr-[2%] w-[50%]">
                      <p className="text-white pb-2   text-2xl">Weekly Progress</p>
                      {/* <Line className=""  data={data}/> */}
                  </div>

                  <div className="border-[1px] shadow-md px-5 py-5 rounded-md shadow-md flex flex-col text-center w-[50%]">
                      <p className="text-white pb-2   text-2xl">Monthly Subject Breakdown</p>
                      {/* <Bar className="text-white"  data={bar_data} /> */}
                      
                  </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  )
}

export default Progress
